module.exports = __webpack_public_path__ + "img/3m.2f943c33.svg";